<template>
  <div class="Codes">
    <div class="content-info">
      <div class="">
        <p class="o-b t-i">Código promocional</p>
        <div class="c-i-c d-i">
          <p class="o-b t-u-c">Codigos promocionales: {{ codeGral }}</p>
        </div>
        <div class="c-i-c-t d-i">
          <p class="o-b t-u-c">Usados: {{ used }}</p>
        </div>
        <div class="c-i-c-t d-i">
          <p class="o-b t-u-c">Disponibles: {{ available }}</p>
        </div>
        <div class="b-c">
          <p class="o-b sub-t">Crear nuevo código promocional</p>
          <div class="row">
            <div class="m-top form-search-m col-md-4">
              <div class="input-group">
                <input v-model="nombre" name="nombre" type="text" class="i-s c-f-g m-top" placeholder="Nombre" />
                <span class="error">{{ errorsN }}</span>
                <input v-model="descripcion" type="text" class="i-s c-f-g m-top" placeholder="Descripción" />
                <span class="error">{{ errorsD }}</span>
                <div class="col-md-12">
                  <div class="row">
                    <input v-model="descuento" type="number" @keypress="isNumber($event)" class="i-s c-f-g m-top col-md-6" maxlength="3" :placeholder="this.is_percentage == 1 ? 'Descuento en porcentaje' : 'Descuento en pesos'" aria-label="Username" aria-describedby="basic-addon1" />
                    <input v-model="is_percentage" type="checkbox" value="1" class="option" />
                    <p class="letter">Porcentaje</p>
                  </div>
                </div>
                <span class="error">{{ errorsDe }}</span>
                <div v-if="is_percentage == 1" style="width: 100%">
                  <input v-model="max_discount" type="text" class="i-s c-f-g m-top" @keypress="isNumber($event)" placeholder="Descuento máximo en pesos (solo si aplica)" aria-label="Username" aria-describedby="basic-addon1"/>
                  <span class="error">{{ errorsMax }}</span>
                </div>
                <input v-model="codigo" type="text" class="i-s c-f-g m-top" placeholder="Ingresa un código" maxlength="12" idaria-label="Codigo" aria-describedby="basic-addon1" />
                <span class="error">{{ errorsCo }}</span>
                <input v-model="cantidad" type="text" class="i-s c-f-g m-top" @keypress="isNumber($event)" placeholder="Cantidad" aria-label="Username" aria-describedby="basic-addon1" />
                <span class="error">{{ errorsCa }}</span>
              </div>
            </div>
            <div class="col-md-3">
              <p>Fecha de expiracion</p>
              <datepicker :monday-first="true" class="calendar" v-model="fecha" name="date" :inline="true" :language="es" :disabledDates="disabledDates"></datepicker>
              <span class="error">{{ errorsFecha }}</span>
              <br />
              <input v-model="reutilizable" type="checkbox" value="1" class="m-top" /> Reutilizable <br />
            </div>
            <div class="col-md-3 a-relative">
              <button v-on:click="send" type="submit" class="btn-f but-g" id="basic-addon1">Crear</button>
            </div>
          </div>
        </div>
        <div class="b-c">
          <p class="o-b sub-t">Códigos promocionales</p>
          <div class="text-center m-top" v-if="codesObject.length == 0">Sin resultados</div>
          <div class="text-center" v-if="codesObject.length > 0">
            <div v-bind:class="{ 'c-t-info-h-active': activeUR }" class="c-t-info">
              <table class="table table-light m-top">
                <thead>
                  <tr>
                    <th scope="col">Codigo</th>
                    <th scope="col">Titulo</th>
                    <th scope="col">Descripción</th>
                    <th scope="col">Descuento</th>
                    <th scope="col">Descuento máximo</th>
                    <th scope="col">Vigencia</th>
                    <th scope="col">Disponibles</th>
                    <th scope="col">Usados</th>
                    <th scope="col">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(o, e) in codesObject" :key="e">
                    <td>{{ o.code }}</td>
                    <td>{{ o.name }}</td>
                    <td>{{ o.description }}</td>
                    <td>{{ o.isPercentage ? `${o.discount}%` : `$${o.discount}` }}</td>
                    <td>{{ o.maxDiscountMxn ? o.maxDiscountMxn : 'ND' }}</td>
                    <td>{{ o.expiration }}</td>
                    <td>{{ o.available }}</td>
                    <td>{{ o.used }}</td>
                    <td>
                      <button class="btn-actions" v-on:click="changeStatus(o)"><img src="@/assets/images/clear.png" alt="acciones" /></button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Promocode from '../parse/models/Promocode'
import Datepicker from 'vuejs-datepicker'
import { en, es } from 'vuejs-datepicker/dist/locale'

var state = {
  date: new Date(2016, 9, 16),
}

export default {
  name: 'Codes',
  components: {
    Datepicker,
  },
  data() {
    return {
      v: '',
      codeGral: 0,
      activeUR: true,
      nombre: '',
      descripcion: '',
      descuento: '',
      cantidad: '',
      date: '',
      en: en,
      es: es,
      datese: '',
      codesObject: {},
      available: 0,
      used: 0,
      formData: {},
      nombre: '',
      descripcion: '',
      descuento: '',
      cantidad: '',
      max_discount: '',
      is_percentage: 1,
      fecha: '',
      codigo: '',
      nuevosUsuarios: 0,
      reutilizable: 0,
      errorsN: '',
      errorsD: '',
      errorsDe: '',
      errorsCo: '',
      errorsCa: '',
      errorsMax: '',
      errorsFecha: '',
      disabledDates: {
        to: new Date(Date.now() - 8640000),
      },
    }
  },
  beforeMount() {
    Promocode.load().then((code) => {
      let countUsed = 0
      let countAvailable = 0
      this.codesObject = code
      for (let i = 0, p = code; i < code.length; i++) {
        countUsed += parseInt(code[i].used)
        countAvailable += parseInt(code[i].available)
      }
      this.used = countUsed
      this.available = countAvailable
    })

    Promocode.count().then((code) => {
      this.codeGral = code
    })
  },

  computed: {
    calcularEdad() {
      console.log(this.used)
      let p = parseFloat(this.used * 0.21)
      return p
    },
  },
  methods: {
    isNumber: function (evt) {
      evt = evt ? evt : window.event
      var charCode = evt.which ? evt.which : evt.keyCode
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },

    reloadTable() {
      Promocode.load().then((code) => {
        this.codesObject = code
      })
    },

    send() {
      if (this.nombre == '') {
        this.errorsN = 'El nombre es requerido'
        return
      }

      this.errorsN = ''

      if (this.descripcion == '') {
        this.errorsD = 'La descripción es requerida'
        return
      }

      this.errorsD = ''

      if (this.descuento == '') {
        this.errorsDe = 'El descuento es requerido'
        return
      } else {
        if (Boolean(this.is_percentage)) {
          if (Number(this.descuento) > 100) {
            this.errorsDe = 'El descuento no debe ser mayor a 100'
            return
          }
        } else {
          if (Number(this.descuento) < 0) {
            this.errorsDe = 'El descuento debe ser positivo'
            return
          }
        }
      }

      this.errorsDe = ''

      if (this.codigo == '') {
        this.errorsCo = 'Es necesario ingresar un código'
        return
      }

      this.errorsCo = ''

      if (this.cantidad == '') {
        this.errorsCa = 'La cantidad es requerida'
        return
      }

      this.errorsCa = ''

      if (this.is_percentage == 1 && this.max_discount && Number(this.max_discount) <= 0) {
        this.errorsMax = 'El descuento maxímo debe ser mayor a 0 (vacio si no aplica)'
        return
      }

      this.errorsMax = ''

      if (this.fecha == '') {
        this.errorsFecha = 'La fecha es requerida'
        return
      }

      this.errorsFecha = ''

      this.formData = {
        nombre: this.nombre,
        descripcion: this.descripcion,
        descuento: this.descuento,
        cantidad: this.cantidad,
        fecha: this.fecha,
        codigo: this.codigo,
        nuevosUsuarios: this.nuevosUsuarios,
        reutilizable: this.reutilizable,
        is_percentage: this.is_percentage,
      }

      console.log(this.max_discount, Number(this.max_discount))

      if(this.is_percentage && this.isNumber(this.max_discount) && Number(this.max_discount) > 0) {
        this.formData.max_discount = Number(this.max_discount)
      } else {
        this.formData.max_discount = undefined
      }

      console.log(this.formData)

      this.$swal({
        title: '',
        text: '¿Estás seguro de que quieres dar de alta este promocode?',
        type: 'warning',
        confirmButtonText: 'Aceptar',
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          this.$swal('', 'Promocode agregado', 'success')
          Promocode.create(this.formData, this.generateId(10)).then((response) => {
            this.reloadTable()
          })
        } else {
          this.$swal('', 'Cancelado', 'info')
        }
      })
    },

    changeStatus(id) {
      this.$swal({
        title: '',
        text: '¿Estás seguro de que quieres eliminar este promocode?',
        type: 'warning',
        confirmButtonText: 'Confirmar',
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          this.$swal('', 'Promocode eliminado', 'success')
          Promocode.changeStatus(id)
            .then((code) => this.reload())
            .catch((error) => console.log(error))
        } else {
          this.$swal('', 'Cancelado', 'info')
        }
      })
    },
    reload() {
      this.formData = {
        nombre: '',
        descripcion: '',
        descuento: '',
        cantidad: '',
        fecha: '',
        codigo: '',
        nuevosUsuarios: 0,
        reutilizable: 0,
      }

      this.reloadTable()
    },
    generateId(len) {
      var arr = new Uint8Array((len || 40) / 2)
      window.crypto.getRandomValues(arr)

      return Array.from(arr, this.dec2hex).join('')
    },
    dec2hex(dec) {
      return ('0' + dec.toString(16)).substr(-2)
    },
  },
  watch: {
    is_percentage(newValue, oldValue) {
      if (newValue == false) {
        this.max_discount = ''
      }
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.option {
  margin-left: 15px;
  margin-top: 25px;
}

.letter {
  margin-left: 10px;
  margin-top: 22px;
}

.calendar > .my-datepicker_calendar {
  width: 100%;
  height: 130px;
}

.a-relative {
  position: relative;
}

.a-relative button {
  position: absolute;
  left: 0;
  bottom: 0;
}

.d-i {
  display: inline-block;
  margin-right: 20px;
}

.c-t-info {
  width: 100%;
  overflow: hidden;
  transition: max-height 0.5s ease-out;
}

.c-t-info-h-active {
  height: auto;
}

/* USER INFO */
.img_user {
  width: 138px;
  height: 138px;
  border-radius: 70px;
  float: left;
  margin-right: 20px;
}

.info-u {
  display: inline;
}

.info-ac button {
  display: inline;
}

table tbody tr {
  background: #f3f3f3;
}

.but-r {
  background: #e96369;
  color: #fff;
  border: 0;
  width: 140px;
  height: 40px;
  border-radius: 10px;
  font-size: 18px;
}

.but-r:hover {
  background: rgb(231, 76, 84);
}

.but-c {
  background: #85eeb3;
  color: #fff;
  border: 0;
  width: 270px;
  height: 40px;
  border-radius: 10px;
  font-size: 18px;
}

.but-c:hover {
  background: #14fc78;
}

.m-r {
  margin-right: 50px;
}

.dropdown-menu {
  width: 120px;
}

/* Container */

.content-info {
  margin-left: 310px;
  margin-right: 50px;
}

.c-i-c {
  width: 250px;
  height: 51px;
  background: #000;
  text-align: center;
  border-radius: 20px;
}

.c-i-c-t {
  width: 200px;
  height: 51px;
  background: #000;
  text-align: center;
  border-radius: 20px;
}

.t-u-c {
  padding-top: 14px;
  color: #fff;
  font-size: 16px;
}

.b-c {
  margin-right: 50px;
  margin-top: 37px;
  border: 1px solid #f6f6f6;
  -webkit-box-shadow: 0px 3px 5px 0px rgba(151, 151, 151, 1);
  -moz-box-shadow: 0px 3px 5px 0px rgba(151, 151, 151, 1);
  box-shadow: 0px 3px 5px 0px rgba(151, 151, 151, 1);
  padding: 15px;
  margin-bottom: 40px;
}

.sub-t {
  font-size: 18px;
  display: inline;
}

.i-f-s {
  width: 25px;
  margin-top: 5px;
  margin-left: 10px;
  margin-right: 10px;
}

.c-f-g {
  background: #f3f3f3;
  border: none;
  padding: 10px;
  height: 40px;
  width: 100%;
  border-radius: 10px;
}

.but-g {
  background: #85eeb3;
  color: #fff;
  border: 0;
  width: 140px;
  height: 40px;
  border-radius: 10px;
  margin: 0 0 0 20px;
}
.but-g:hover {
  background: #14fc78;
}

.but-b {
  background: #000;
  color: #fff;
  border: 0;
  width: 200px;
  height: 40px;
  border-radius: 10px;
}
.but-b:hover {
  background: rgb(27, 27, 27);
}

.btn-f {
  margin: 0 40px 0 20px;
}

.f-r {
  float: right;
}

.s-o {
  background: #f3f3f3;
  border: none;
  font-family: 'Open regular';
  font-size: 16px;
  padding: 5px;
  width: 200px;
}

.s-o option {
  padding: 5px;
}

.table {
  border: 1px solid #f6f6f6;
  text-align: center;
}
.btn-actions {
  background: #f6f6f6;
  border: none;
}
</style>
